import { useParams } from "react-router-dom"
import { FlyerType } from "../FlyerTypePicker";


export const useFlyerConfig = () => {
  const { flyerType, flyerLocale } = useParams();
  return {
    flyerType: flyerType as FlyerType,
    flyerLocale
  }
}